import { graphql } from '@lib/graphql'
import { execute } from '@lib/graphql/execute'
import {
  CustomerPasswordResetTokenDocument,
  CustomerPasswordResetTokenInput,
} from '@lib/graphql/graphql'

export const customerResetPasswordTokenMutation = graphql(`
  mutation CustomerResetPasswordToken(
    $input: CustomerPasswordResetTokenInput!
  ) {
    customerPasswordResetToken(input: $input) {
      errors {
        __typename
      }
    }
  }
`)

export const customerResetPasswordToken = (
  input: CustomerPasswordResetTokenInput,
) => {
  return execute(CustomerPasswordResetTokenDocument, {
    input,
  })
}
